import React from "react";

/**
 * Catches any uncaught React render error and shows a diagnostic page
 * instead of blanking to white. Critical for production so we can see what broke.
 */
export class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { error: null };
  }
  static getDerivedStateFromError(error) {
    return { error };
  }
  componentDidCatch(error, info) {
    // eslint-disable-next-line no-console
    console.error("[RivetQuote] Render error:", error, info);
  }
  render() {
    if (this.state.error) {
      const backendUrl = process.env.REACT_APP_BACKEND_URL || "(not set)";
      return (
        <div style={{
          minHeight: "100vh", padding: 40, fontFamily: "Inter, system-ui, sans-serif",
          background: "#F1F5F9", color: "#001F3F",
        }}>
          <div style={{ maxWidth: 720, margin: "0 auto" }}>
            <div style={{
              fontSize: 12, textTransform: "uppercase", letterSpacing: "0.25em",
              color: "#EF4444", fontWeight: 700,
            }}>
              Something went wrong
            </div>
            <h1 style={{ fontSize: 32, fontWeight: 900, margin: "12px 0" }}>
              RivetQuote couldn&apos;t start.
            </h1>
            <p style={{ color: "#334155" }}>
              The page hit an unexpected error. Open your browser console for details.
            </p>
            <div style={{
              marginTop: 24, padding: 16, background: "white",
              border: "1px solid #E2E8F0", borderRadius: 8,
              fontFamily: "ui-monospace, monospace", fontSize: 12, whiteSpace: "pre-wrap",
            }}>
              <div><b>Error:</b> {String(this.state.error?.message || this.state.error)}</div>
              <div style={{ marginTop: 8 }}><b>Backend URL:</b> {backendUrl}</div>
            </div>
            <button
              onClick={() => window.location.reload()}
              style={{
                marginTop: 20, padding: "10px 20px", borderRadius: 999,
                background: "#2563EB", color: "white", border: "none",
                fontWeight: 600, cursor: "pointer",
              }}
            >
              Reload
            </button>
          </div>
        </div>
      );
    }
    return this.props.children;
  }
}

export default ErrorBoundary;
